export default __webpack_public_path__ + "static/media/collected.c534eb73.svg";